export default (request, entities, translators) => ({
  findAll({ page, status }) {
    return request('GET', `estates?for_org=true&page=${page}&status=${status}`)
      .then((estates) => ({
        estates: estates.estates.map((estate) => ({
          ...estate.estate,
          items: estate.items.map((item) => translators.ProjectItem.fromServer(item.item)),
        })),
        lastPage: estates.last_page,
      }))
      .then(({ estates, lastPage }) => ({
        projects: estates.map(translators.Project.fromServer),
        meta: { lastPage },
      }));
  },
});
